import React from 'react'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core'
import { styles } from './ActionMenu.styles'

const useStyles = makeStyles(() => styles)

export const ActionMenu = ({ id, actions, onActionClick }) => {
  const classes = useStyles()

  const handleActionClick = action => {
    action(id)
    if (onActionClick) {
      onActionClick()
    }
  }

  return (
    <div className={classes.menuContainer}>
      {actions.map(({ action, label, className }) => (
        <button
          key={label}
          className={classNames(classes.menuButton, className)}
          onClick={() => handleActionClick(action)}
        >
          {label}
        </button>
      ))}
    </div>
  )
}
